import axios from "axios";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { Button } from "reactstrap";
import { baseurl } from "../../../../baseurl";
import ExportToExcel from "../../SExport/ExportToExcle";
import ReportsCriteria from "../../ShortCutComponents/ReportsCriteria";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "../../../../stickyHeaderReport.css";
import "./formsTableSaleDetail.css";
import { checkPermission } from "../../../../Helper";
import { generateCriteriaString } from "../../ShortFunction/shortFunctions";
import "./baseForms.css";
import swal from "sweetalert";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");

function due_Formators(cell, row, enumObject, index) {
  let newCell = "";
  newCell = cell;
  if (typeof cell === "string") {
    newCell = parseFloat(cell);
  }

  if (newCell) {
    newCell = newCell?.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  } else {
    newCell = "-";
  }
  return newCell;
}
export default function SalesReportAllBranchesSalesChannelWise(props) {
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [data, setData] = useState({
    fromDate: "",
    toDate: "",
    customer: "",
    clientLov: "",
    customer_id: "",
    customerName: "",
    customerEmail: "",
    criteriaString: "All",
    checkboxBtnInvoice: "",
    checkboxBtnDraft: "",
    collapseCriteria: false,
  });
  const [permission, setPermission] = useState(true);

  const listOfColKey = [
    { align: "left", value: "sub_inv_desc" },
    { align: "right", value: "Shop_Sales" },
    { align: "right", value: "Blink" },
    { align: "right", value: "Food_Panda" },
    { align: "right", value: "Total" },
  ];
  const listOfColLables = [
    { align: "center", value: "sub_inv_desc" },
    { align: "center", value: "Shop_Sales" },
    { align: "center", value: "Blink" },
    { align: "center", value: "Food_Panda" },
    { align: "center", value: "Total" },
  ];

  const [table, setTable] = useState({
    OverViewDataTable: [],
    filteredData: [],
  });
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const funCall = async () => {
      await asyncRollCheck();
      // getAccountsSummary();
    };

    funCall();
  }, []);
  const asyncRollCheck = async () => {
    let rolId = 2;
    let adminRoleId = 1;
    let readYn = 1;
    let writeYn = 0;
    let empId = localStorage.getItem("employeeId");
    let makeTrueFlase = "";
    let hideShowDiv;
    let formType = "OverView";
    let permissionFunction = await checkPermission(
      empId,
      adminRoleId,
      rolId,
      readYn,
      writeYn,
      formType,
    );

    if (permissionFunction[1] == 1 && permissionFunction[2] == 0) {
      hideShowDiv = "hideShowDiv";
    } else {
      hideShowDiv = "";
    }

    setPermission(permissionFunction[0]);
  };

  const getAccountsSummary = (startDate, endDate) => {
    let sysDate = moment(new Date()).format("YYYY-MM-DD");

    let sDate = startDate ? moment(startDate).format("YYYY-MM-DD") : sysDate;
    let eDate = endDate ? moment(endDate).format("YYYY-MM-DD") : sysDate;
    setLoadingResponce(true);

    axios
      .post(
        `${baseurl}/repots/getSalesReportAllBranchesSalesChannelWise`,
        {
          companyId: companyId,
          fromDate: sDate,
          toDate: eDate,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )

      .then(function (response) {
        let callData = response.data.data;
        setLoadingResponce(false);
        let todayDate = new Date();
        if (callData.length > 0) {
          todayDate = moment(todayDate).format("YYYY-MM-DD");
          callData.reverse();
          let totalSumAll = {
            sumShop_Sales: 0,
            sumBlink: 0,
            sumFood_Panda: 0,
            sumOther: 0,
            sumTotal: 0,
          };
          let objEmpty = {
            sub_inv_desc: "",
            Shop_Sales: "",
            Blink: "",
            Food_Panda: "",
            Total: "",
          };
          let newArr = [
            {
              sub_inv_desc: "Sales Report All Branches Sales Channel Wise",
              Shop_Sales: "",
              Blink: "",
              Food_Panda: "",
              Total: `*Note : All figures indicated are in the company currency (  ${companySymbolCurrency} )`,
            },
            objEmpty,
            {
              sub_inv_desc: "Branch",
              Shop_Sales: "Cash",
              Blink: "Card",
              Food_Panda: "Blink Cash",
              Total: "Fp Cash",
            },
          ];
          let sumShop_Sales = 0;
          let sumBlink = 0;
          let sumFood_Panda = 0;
          let sumOther = 0;
          let sumTotal = 0;

          let printData = [];
          let pdfDataArray = [];

          for (let index = 0; index < callData.length; index++) {
            let element = callData[index];

            sumShop_Sales = sumShop_Sales + Number(element?.Shop_Sales);
            sumBlink = sumBlink + Number(element?.Blink);
            sumFood_Panda = sumFood_Panda + Number(element?.Food_Panda);
            sumTotal = sumTotal + Number(element?.Total);

            totalSumAll = {
              sumShop_Sales:
                totalSumAll.Shop_Sales + Number(element?.Shop_Sales),
              sumBlink: totalSumAll.Blink + Number(element?.Blink),
              sumFood_Panda:
                totalSumAll.Food_Panda + Number(element?.Food_Panda),
              sumTotal: totalSumAll.Total + Number(element?.Total),
            };

            newArr.push({
              sub_inv_desc: element["sub_inv_desc"],
              Shop_Sales: element["Shop_Sales"],
              Blink: element["Blink"],
              Food_Panda: element["Food_Panda"],
              Total: element["Total"],
            });
            printData.push({
              sub_inv_desc: element["sub_inv_desc"],
              Shop_Sales: due_Formators(element["Shop_Sales"]),
              Blink: due_Formators(element["Blink"]),
              Food_Panda: due_Formators(element["Food_Panda"]),
              Total: due_Formators(element["Total"]),
            });
            pdfDataArray.push({
              sub_inv_desc: element["sub_inv_desc"],
              Shop_Sales: due_Formators(element["Shop_Sales"]),
              Blink: due_Formators(element["Blink"]),
              Food_Panda: due_Formators(element["Food_Panda"]),
              Total: due_Formators(element["Total"]),
            });
          }

          newArr.push(objEmpty);
          newArr.push({
            sub_inv_desc: "Total",
            Shop_Sales: sumShop_Sales.toFixed(2),
            Blink: sumBlink.toFixed(2),
            Food_Panda: sumFood_Panda.toFixed(2),
            Total: sumTotal.toFixed(2),
          });
          let mainScreenDataTable = [...printData];

          printData.push({
            sub_inv_desc: "Total",
            Shop_Sales: due_Formators(sumShop_Sales),
            Blink: due_Formators(sumBlink),
            Food_Panda: due_Formators(sumFood_Panda),
            Total: due_Formators(sumTotal),
          });
          pdfDataArray.push({
            sub_inv_desc: "Total",
            Shop_Sales: due_Formators(sumShop_Sales),
            Blink: due_Formators(sumBlink),
            Food_Panda: due_Formators(sumFood_Panda),
            Total: due_Formators(sumTotal),
          });

          setTable({
            ...table,
            OverViewDataTable: mainScreenDataTable,
            totalSumAll,
            mainScreenDataTable,
            printData,
            listOfData: newArr,
            pdfDataArray,
          });
          setFilteredData(mainScreenDataTable);
        } else {
          setTable({
            ...table,
            OverViewDataTable: [],
            totalSumAll: [],
            mainScreenDataTable: [],
            printData: [],
            listOfData: [],
          });
          setFilteredData([]);
        }
      })
      .catch(function (error) {
        setLoadingResponce(false);
        console.log(error);
      });
  };

  const funPrintView = (data1, headers, headerKeyMap, allData) => {
    let fromDate = allData.fromDate
      ? moment(allData.fromDate).format("DD-MMM-YYYY")
      : "All";
    let toDate = allData.toDate
      ? moment(allData.toDate).format("DD-MMM-YYYY")
      : "All";

    let dateCriteria =
      fromDate === "All" && toDate === "All"
        ? {
            label: "Date",
            value: "All",
          }
        : ({
            label: "From Date",
            value: fromDate,
          },
          {
            label: "To Date",
            value: toDate,
          });
    let criteria = [dateCriteria];
    const reportState = {
      data: data1,
      pdfDataArray: table.pdfDataArray,
      headers: headers,
      headerKeyMap: headerKeyMap,
      goBackUrl: "/SalesReportSalesChannelWise",
      dynamicInvMessage: "Sales Report All Branches Sales Channel Wise",
      reportName: "Sales_Report_All_Branches_Sales_Channel_Wise",
      criteria,
      criteriaString: data.criteriaString,
    };
    localStorage.setItem("reportState", JSON.stringify(reportState));
    window.open("#/PrintReportsNew", "_blank");
    // props.history.push({
    //   pathname: "/PrintReports",
    //   state: {
    //     data: data1,
    //     pdfDataArray: table.pdfDataArray,
    //     headers: headers,
    //     headerKeyMap: headerKeyMap,
    //     goBackUrl: "/SalesReportSalesChannelWise",
    //     dynamicInvMessage: "Sales Report All Branches Sales Channel Wise",
    //     reportName: "Sales_Report_All_Branches_Sales_Channel_Wise",
    //     criteria,
    //     criteriaString: data.criteriaString,
    //   },
    // });
  };
  const graph = () => {
    swal({
      title: "Coming Soon",
      text: "This feature is under development",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });
  };

  const handleDynamicColapse = (p) => {
    console.log("p", p);
    const { collapseCriteria } = p;
    setData({
      ...data,
      collapseCriteria,
    });
  };
  const sendSearchedData = (p) => {
    console.log("p", p);
    const { filteredData } = p;
    setFilteredData(filteredData);
  };
  const handleFind = (p) => {
    const { fromDate, toDate } = p;

    console.log("p", p);
    const critObj = {
      fromDate,
      toDate,
    };
    const criteriaString = generateCriteriaString(critObj);
    setData({
      criteriaString: criteriaString,
    });
    console.log("criteriaString :>> ", criteriaString);
    getAccountsSummary(fromDate, toDate);
  };
  const parseMoney = (value) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === "number") return value;
    if (typeof value === "string")
      return parseFloat(value.replace(/,/g, "")) || 0;
    return 0;
  };

  const sumShop_Sales = filteredData.reduce(
    (acc, item) => acc + parseMoney(item.Shop_Sales),
    0,
  );
  const sumBlink = filteredData.reduce(
    (acc, item) => acc + parseMoney(item.Blink),
    0,
  );
  const sumFood_Panda = filteredData.reduce(
    (acc, item) => acc + parseMoney(item.Food_Panda),
    0,
  );

  const sumTotal = filteredData.reduce(
    (acc, item) => acc + parseMoney(item.Total),
    0,
  );

  const columns = [
    {
      dataField: "sub_inv_desc",
      text: "Branch",
      style: {
        textAlign: "Center",
      },
      footer: "Total",
      footerStyle: {
        textAlign: "Center",
      },
    },
    {
      dataField: "Shop_Sales",
      text: "Shop Sales",
      sort: true,
      footer: () => new Intl.NumberFormat().format(sumShop_Sales),
      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "Blink",
      text: "Blink",
      sort: true,
      footer: () => new Intl.NumberFormat().format(sumBlink),
      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    {
      dataField: "Food_Panda",
      text: "Food Panda",
      sort: true,
      footer: () => new Intl.NumberFormat().format(sumFood_Panda),
      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
    // {
    //     dataField: "Other",
    //     text: "Other",
    //     sort: true,
    //     footer: () => new Intl.NumberFormat().format(sumOther),
    //     style: {
    //         textAlign: "right",
    //     },
    //     footerStyle: {
    //         textAlign: "right",
    //     },
    // },
    {
      dataField: "Total",
      text: "Total",
      sort: true,
      footer: () => new Intl.NumberFormat().format(sumTotal),
      style: {
        textAlign: "right",
      },
      footerStyle: {
        textAlign: "right",
      },
    },
  ];
  const defaultSorted = [
    {
      dataField: "sub_inv_desc",
      order: "desc",
    },
  ];
  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to last",
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "All", value: filteredData?.length || 100 }, // fallback
    ],
    custom: true,
  };

  console.log("filteredData :>> ", filteredData);

  return (
    <>
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            loadingResponce ? "blur-background" : ""
          }`}
        >
          <ReportsCriteria
            reportName="Sales Report All Branches Sales Channel Wise"
            lovs={[]}
            companyId={companyId}
            token={token}
            username={username}
            isMulti={true}
            handleFind={(p) => handleFind(p)}
            tableData={table.OverViewDataTable}
            callBack={(p) => handleDynamicColapse(p)}
            sendSearchedData={(p) => sendSearchedData(p)}
          />

          <div className="row float-right pr-4">
            <Button
              color="secondary"
              className="button-22"
              onClick={() => graph()}
              id="invoiceButton"
            >
              Graph
            </Button>
            <Button
              color="success"
              className="button-22 "
              onClick={() =>
                funPrintView(
                  table.printData,
                  listOfColLables,
                  listOfColKey,
                  data,
                )
              }
              id="invoiceButton"
            >
              Print
            </Button>

            {table?.listOfData?.length > 0 ? (
              <ExportToExcel
                Data={table?.listOfData}
                listOfColKey={listOfColKey}
                DynamicReports={true}
                ReportName="Sales_Report_All_Branches_Sales_Channel_Wise"
                criteriaString={data.criteriaString}
              />
            ) : null}
          </div>
          <div className="mt-5" translate="no">
            <div className="sticky-table-wrapper">
              <div className="sticky-table-container">
                <PaginationProvider pagination={paginationFactory(options)}>
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      <div className="d-flex justify-content-between align-items-center my-2">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                      </div>

                      <BootstrapTable
                        keyField="id"
                        data={filteredData}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        headerClasses="rpr_header"
                        tableBodyClass="rpr_body"
                        containerClass="rpr_container"
                        striped
                        condensed
                        hover
                        {...paginationTableProps}
                      />
                    </div>
                  )}
                </PaginationProvider>
              </div>
            </div>
          </div>
        </div>
        {loadingResponce && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
